'use strict';

module.exports = function isNegativeZero(number) {
	return number === 0 && (1 / number) === -Infinity;
};




//////////////////
// WEBPACK FOOTER
// ./node_modules/.2.0.0@is-negative-zero/index.js
// module id = 738
// module chunks = 1